import React, { Component } from "react";
import NavigationChange from "../../components/NavigationChange";
import { Button, Form, Modal } from "react-bootstrap";
import Pagination from "@mui/material/Pagination";
import VehiclesGrid from "./VehiclesGrid";
import CreateVehicles from "./CreateVehicles";
import VechiclesApi from "../../api/VechiclesApi";
import AuthService from "../../session/AuthService";
import { Toaster, toast } from "react-hot-toast";
import CreateServiceRecord from "../ServiceRecordPackage/CreateServiceRecord";
import ManageUserService from "../../api/ManageUserService";
import ServiceRecordsModal from "../ServiceRecordPackage/ServiceRecordsModal";
import EquipmentApi from "../../api/EquipmentApi";
import BuildingsApi from "../../api/BuildingsApi";
import { Menu, MenuItem } from "@mui/material";
import * as XLSX from "xlsx";

class VehiclesConatiner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      VechiclesList: [],
      vechiclesCount: 0,
      totalPageNO: null,
      totalExpiredVehicleNo: 0,
      changeStateforEdit: false,
      changeStateforEditforCreateServiceRecord: false,
      pageNo: 0,
      search: "",
      currentPage: 1,
      activeServiceRecord: false,
      userList: [],
      totalresourceValue: {},
      resourseValue: 0,
      openListServiceRecord: false,
      commonArrays: [],
      serviceforresourceIdclose: 0,
      anchorEl: null,
      filterBy: "",
    };
  }

  componentDidMount = () => {
    this.getVehicleList();
    this.togetEmployeeData();
    this.DropDownVechcile();
    toast.dismiss();
  };

  togetEmployeeData = () => {
    let obj = { group_id: parseInt(AuthService.getUserId()) };

    ManageUserService.getAllUserData(obj).then((response) => {
      console.log("response in userData", response);
      if (response.data && response.data.data) {
        this.setState({
          userList: response.data.data.UserData,
        });
      }
    });
  };

  getVehicleList = () => {
    let obj = {
      group_id: parseInt(AuthService.getUserId()),
      page: 0,
      search: "",
      filterBy: this.state.filterBy,
    };

    this.getVehicleDetails(obj);

    // VechiclesApi.getVehicleList(obj).then((response) => {
    //   console.log("response in vecicle list", response);
    //   if (response.data && response.data.message === "Success") {
    //     this.setState({
    //       VechiclesList: response.data.data.vehicleList,
    //       vechiclesCount: response.data.data.totalCount,
    //       totalPageNO: response.data.data.totalPageno,
    //       totalExpiredVehicleNo: response.data.data.totalExpiredVehicleNo
    //     });
    //   }
    // });
  };

  DropDownVechcile = () => {
    let obj = {
      group_id: AuthService.getUserId(),
    };

    BuildingsApi.getVehicleData(obj).then((response) => {
      if (response.data && response.data.data) {
        this.setState({
          commonArrays: response.data.data.vehicleData,
        });
      } else {
      }
    });
  };

  render() {
    return (
      <>
        {/* <iframe id="pdfFrame" src="" height="100%" width="100%" style={{height:"30rem"}}></iframe> */}

        <div className="Heading">
          <NavigationChange
            Topics={"Vehicle"}
            numberofRecord={this.state.vechiclesCount}
            specficwidth={"105"}
            back={true}
            totalExpired={this.state.totalExpiredVehicleNo}
          />
        </div>
        <div className="container-of-createButton" id="titleWithDropdowns">
          <div className="d-flex flex-row">
            <div className="search-contain me-3">
              <Form.Label style={{ fontSize: "17px" }}>Search</Form.Label>

              <div className="search">
                <span className="fa fa-search" onClick={this.search}></span>
                <input
                  type="text"
                  placeholder="Type Here..."
                  name="search"
                  value={this.state.search}
                  onKeyPress={this.handleKeyPress}
                  onChange={this.searchvalue}
                />
              </div>
            </div>
            <div className="resource-conatiner">
              <Form.Label style={{ fontSize: "17px" }}>Filter By Safety</Form.Label>
              <select
                value={this.state.sortBy}
                onChange={(event) => this.filterByMethod(event.target.value)}
                style={{
                  backgroundColor: "#F3F4F1",
                  color: "#000",
                  borderColor: "#F3F4F1",
                  width: "100%",
                  height: "36px",
                  borderRadius: "5px",
                }}
              >
                <option value="">All Vehicles</option>
                <option value="expiryDate">Expired</option>
                <option value="expiringSoon">Expiring Soon & Expired</option>
                <option value="safety">Safety Expiry Vehicles</option>
              </select>
            </div>
          </div>
          <div
            className="create-button"
            style={{ display: "flex", gap: "15px" }}
          >
            {AuthService.getUserTypeAdmin() !== "3" && (
              <div className="button-end">
                <button
                  className="btn btn-success"
                  onClick={this.OpendownloadDialouge}
                  style={{
                    backgroundColor: "#8ABC49",
                    borderColor: "#8ABC49",
                  }}
                >
                  <i
                    class="fa fa-download"
                    aria-hidden="true"
                    style={{ marginRight: "5px" }}
                  ></i>
                  Download Report
                </button>
              </div>
            )}

            {AuthService.getUserTypeAdmin() !== "3" && (
              <div className="button-end">
                <button
                  className="btn btn-success"
                  onClick={this.OpenCreateTask}
                  style={{
                    backgroundColor: "#8ABC49",
                    borderColor: "#8ABC49",
                  }}
                >
                  Add Vehicle
                </button>
              </div>
            )}
          </div>
          <Menu
            anchorEl={this.state.anchorEl}
            open={Boolean(this.state.anchorEl)}
            onClose={this.handleFilterClose2}
            className="exclude-menu"
          >
            <MenuItem onClick={(e) => this.handleFilterClose(true)}>
              <span className="inisde-the-action">Active Registration</span>
            </MenuItem>
            <MenuItem onClick={() => this.handleFilterClose(false)}>
              <span className="inisde-the-action">Non-Active Registration</span>
            </MenuItem>
            <MenuItem onClick={() => this.handleFilterClose(null)}>
              <span className="inisde-the-action">Safety Expiry</span>
            </MenuItem>
          </Menu>
        </div>
        <VehiclesGrid
          VechiclesList={this.state.VechiclesList}
          ActiveEdit={(e) => this.ActiveEdit(e)}
          onLoad={this.getVehicleList}
          pageLoad={this.pageLoad}
          openCreateServiceRecord={(e) => this.openCreateServiceRecord(e)}
          openListServiceRecord={(e) => this.openListServiceRecord(e)}
          getVechicleName={(a) => this.getVechicleName(a)}
        />

        <div className="mt-2" style={{ width: "99%", margin: "0 auto" }}>
          <div className="d-flex justify-content-center">
            <Pagination
              count={this.state.totalPageNO}
              onChange={(event, value) => this.handlePageChange(value)}
              page={this.state.currentPage}
            />
          </div>
        </div>

        {this.state.openModal && (
          <CreateVehicles
            handleClose={this.closeHandleclose}
            show={this.state.openModal}
            onLoad={this.getVehicleList}
            option={!this.state.changeStateforEdit ? "new" : "edit"}
            editValue={this.state.editValue}
            renderToast={(a) => this.renderToast(a)}
            errorToast={(a) => this.errorToast(a)}
            pageLoad={this.pageLoad}
          />
        )}

        {this.state.activeServiceRecord && (
          <>
            <CreateServiceRecord
              show={this.state.activeServiceRecord}
              handleClose={this.closeCreateServiceRecord}
              option={!this.state.changeStateforEdit ? "new" : "edit"}
              userList={this.state.userList}
              comefrom={"vehicle"}
              Type={3}
              commonArrays={this.state.commonArrays}
              service_resourceId={this.state.resourseValue}
              renderToast={(e) => this.renderToast2(e)}
              editValue={this.state.editValue}
              openListofServiceRecord={(e) =>
                this.openListServiceRecordAgain(e)
              }
            />
          </>
        )}

        {this.state.openListServiceRecord && (
          <>
            <ServiceRecordsModal
              handleClose={this.closeListServiceRecord}
              show={this.state.openListServiceRecord}
              fulldata={this.state.resourcefullData}
              userList={this.props.userList}
              ActiveEdit={(a) => this.activeEdit(a)}
              openExistingForm={(e) => this.openExistingForm(e)}
              openplusIcon={this.state.openplusIcon}
              closeopenPlusIcon={this.closeplusIcon}
              machineName={this.state.machineName}
              openDeleteFunction={(e) => this.openDeleteFunction(e)}
            />
          </>
        )}
        {this.state.opendeleteproductDialogue && this.deleteproductPopUp()}
        <Toaster />
      </>
    );
  }

  handleFilterClose2 = () => {
    this.setState({
      anchorEl: null,
    });
  };

  handleFilterClose = (status) => {
    let obj = {
      activeRegistration: status,
      group_id: AuthService.getUserId(),
    };

    VechiclesApi.getVehicleReport(obj).then((response) => {
      console.log("response", response.data.data);

      this.setState(
        {
          reportData: response.data.data,
        },
        () => {
          if (response.data.data.length > 0) {
            const { reportData } = this.state;


            // Format data
            const formattedData = reportData.map((item) => ({
              "Vehicle Name": item.vehicle_name || "",
              "Plate Number": item.plateNumber || "",
              "Policy Number": item.policyNumber || "",
              "Active Registration": item.activeRegistration
                ? "Active"
                : "Inactive",
              // "Safety Expiry Date": item.expiryDate || "No Expiry Date",
              "Safety Expiry Date": item.expiryDate ? String(item.expiryDate) : "No Expiry Date",

            }));

            // Convert JSON data to worksheet
            const ws = XLSX.utils.json_to_sheet(formattedData);

            // Adjust column width based on content length
            const columnOrder = Object.keys(formattedData[0]); // Dynamic keys
            const columnWidths = formattedData.reduce((acc, curr) => {
              columnOrder.forEach((key, index) => {
                const cellLength =
                  curr[key] !== undefined && curr[key] !== null
                    ? curr[key].toString().length
                    : 0;
                acc[index] = Math.max(acc[index] || 0, cellLength);
              });
              return acc;
            }, []);

            ws["!cols"] = columnWidths.map((width) => ({ width: width * 1.5 }));

            // Create workbook and write to file
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "VehicleList");
            XLSX.writeFile(wb, "VehicleList.xlsx");

            this.handleFilterClose2();
          } else {
            this.errorToast("No Data Found");
          }
        }
      );
    });
  };

  OpendownloadDialouge = (event) => {
    this.setState({
      anchorEl: event.target,
    });
  };

  getVechicleName = (e) => {
    this.setState({
      machineName: e.vehicle_name,
    });
  };

  closeplusIcon = () => {
    this.setState({
      openplusIcon: false,
    });
  };

  openExistingForm = (e) => {
    this.setState(
      {
        changeStateforEdit: false,
        activeServiceRecord: true,
        showOption: false,
        resourseValue: e.service_resourceId,
      },
      () => {
        console.log("state value", this.state);
      }
    );
  };

  openDeleteFunction = (e) => {
    console.log(e, "delete ifd");
    this.setState(
      {
        opendeleteproductDialogue: true,
        showfinalValue: e.servicerecord_Id,
        fulldata: e,
      },
      () => {
        console.log("state values", this.state.showfinalValue);
      }
    );
  };

  activeEdit = (a) => {
    console.log("a", a);
    this.setState({
      changeStateforEdit: true,
      editValue: a,
      activeServiceRecord: true,
      showOption: true,
    });
  };

  closeListServiceRecord = () => {
    this.setState({
      openListServiceRecord: false,
    });
  };

  openListServiceRecordAgain = (e) => {
    console.log("e in openServiceRecordList", e);

    console.log("open list of servicerecord", e);
    let obj = {
      service_type: 3,
      service_resourceId: e.service_resourceId,
    };

    EquipmentApi.togetFullDataByServiceTypeandResourceId(obj).then(
      (response) => {
        console.log(response, "response");
        alert("response::", response);
        if (response.data && response.data.message === "success") {
          if (response.data.data.length > 0) {
            this.setState({
              resourcefullData: response.data.data,
              openListServiceRecord: true,
              openplusIcon: true,
              serviceforresourceIdclose: e.service_resourceId,
            });
          } else {
            this.getVehicleList();
          }
        }
      }
    );
  };

  getVehicleDetails = (obj) => {
    VechiclesApi.getVehicleList(obj).then((response) => {
      console.log("response in vecicle list", response);
      if (response.data && response.data.message === "Success") {
        this.setState({
          VechiclesList: response.data.data.vehicleList,
          vechiclesCount: response.data.data.totalCount,
          totalPageNO: response.data.data.totalPageno,
          totalExpiredVehicleNo: response.data.data.totalExpiredVehicleNo,
        });
      }
    });
  };

  filterByMethod = (filterBy) => {
    this.setState({ filterBy: filterBy, pageNo: 0 }, () => {
      let obj = {
        page: this.state.pageNo,
        search: this.state.search,
        filterBy: this.state.filterBy,
        group_id: parseInt(AuthService.getUserId()),
      };
      this.getVehicleDetails(obj);
    });
  };

  openListServiceRecord = (e) => {
    let obj = {
      service_type: 3,
      service_resourceId: e.vehicle_id,
    };

    EquipmentApi.togetFullDataByServiceTypeandResourceId(obj).then(
      (response) => {
        console.log(response, "response");
        if (response.data && response.data.message === "success") {
          if (response.data.data.length > 0) {
            this.setState({
              resourcefullData: response.data.data,
              openListServiceRecord: true,
              openplusIcon: true,
              machineName: e.vehicle_name,
              serviceforresourceIdclose: e.vehicle_id,
            });
          } else {
            this.getVehicleList();
          }
        }
      }
    );
  };

  closeCreateServiceRecord = () => {
    this.setState(
      {
        activeServiceRecord: false,
      },
      () => {}
    );
  };

  openCreateServiceRecord = (e) => {
    console.log("e in createServiceRecord", e);
    this.setState({
      activeServiceRecord: true,
      resourseValue: e.vehicle_id,
      totalresourceValue: e,
      changeStateforEdit: false,
    });
  };

  searchvalue = (event) => {
    this.setState(
      {
        [event.target.name]: event.target.value,
      },
      () => {
        if (event.target.value.length === 0) {
          this.search();
        }
      }
    );
  };

  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      this.search();
    }
  };

  search = () => {
    let obj = {
      group_id: parseInt(AuthService.getUserId()),
      page: 0,
      search: this.state.search,
      filterBy: this.state.filterBy,
    };
    this.getVehicleDetails(obj);
  };

  handlePageChange = (i) => {
    let page = null;
    if (i === 1) {
      page = 0;
    } else {
      page = i - 1;
    }
    this.setState({ currentPage: i, pageNo: page }, () => {
      let obj = {
        page: this.state.pageNo,
        search: this.state.search,
        group_id: parseInt(AuthService.getUserId()),
        filterBy: this.state.filterBy,
      };

      this.getVehicleDetails(obj);
    });
  };

  OpenCreateTask = () => {
    this.setState({
      openModal: true,
      changeStateforEdit: false,
    });
  };

  closeHandleclose = () => {
    this.setState({
      openModal: false,
    });
  };

  ActiveEdit = (a) => {
    this.setState({
      changeStateforEdit: true,
      editValue: a,
      openModal: true,
    });
  };

  renderToast2 = (status) => {
    toast.success(`Service Record  ${status} Successfully`);
  };

  renderToast = (status) => {
    toast.success(`Vehicle ${status} Successfully`);
  };

  errorToast = (status) => {
    toast.error(`${status} `);
  };

  pageLoad = () => {
    let obj = {
      group_id: parseInt(AuthService.getUserId()),
      page: this.state.pageNo,
      search: "",
      filterBy: this.state.filterBy,
    };

    this.getVehicleDetails(obj);
  };

  deleteproductPopUp = () => {
    return (
      <Modal show={true} size="md" centered onHide={this.deletehandleClose}>
        <Modal.Header closeButton className="CNSHeader">
          <h3 className="titleMd uppercase">Delete Service Record</h3>
        </Modal.Header>

        <Modal.Body className="">
          <div className="basicInfoWrapper newServiceFormWrapper">
            <Form.Group className="mb-3" controlId="formBasicName">
              <Form.Label>
                Are you sure to Delete this Service Record
              </Form.Label>
            </Form.Group>
          </div>
        </Modal.Body>
        <Modal.Footer className="CNSFooter">
          <Button variant="secondary" onClick={this.deletehandleClose}>
            Close
          </Button>
          <Button
            variant="success"
            type="button"
            onClick={this.deleteServiceRecord}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  deletehandleClose = () => {
    this.setState({
      opendeleteproductDialogue: false,
      openListServiceRecord: [],
    });
  };

  deleteServiceRecord = () => {
    let obj = {
      servicerecord_Id: this.state.showfinalValue,
    };

    EquipmentApi.deleteServiceRecord(obj).then((response) => {
      console.log("response : ", response);
      if (response.data && response.data.message === "success") {
        this.deletehandleClose();
        this.openListServiceRecordAgain(response.data.data);
      }
    });
  };
}
export default VehiclesConatiner;
